import { ReportDefinition, TargetEntityType, ReportMetaDataContext, TargetCriterias } from "./reportMetaData";
import { ComponentHelper } from "../core/util/componentHelper";
import { IsSearchField } from "../core/components/isSearchField";
import { Button, ButtonProps } from "../core/components/button";
import { Helper } from "../core/util/helper";
import { FieldInstance } from "../core/components/field";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Sheet, SheetEventType } from "../../siteManagement/sheet";
import { General } from "../../siteManagement/general";
import { DialogHelper } from "../core/util/dialogHelper";
import { ReportMetaDataHelper } from "./reportMetaDataHelper";
import { BaseField } from "../core/components/baseComponentProps";
import React from "react";
export default class TargetCriteria extends React.Component<TargetCriteriaProps, TargetCriteriaState> {
    private targetEntityType: TargetEntityType;
    private tagMultiSelectRef: TagMultiSelect
    private factory = ComponentHelper.createFactory();
    private baseTagList: string[] = [];
    private sheet: Sheet;
    private contentStyle: React.CSSProperties = {
        height: "27px",
        display: "flex",
        alignItems: "center"
    };
    private labelStyle: React.CSSProperties = {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "inline-block",
        height: "18px",
        width: "auto",
        paddingTop: "3px"
    }
    private addTagButtonVisible: boolean;
    private crTemplate;
    constructor(props: TargetCriteriaProps) {
        super(props);
        let state: TargetCriteriaState = {
            type: TargetCriteriaType.None,
            kNrs: [],
            templates: [],
            tags: []
        }
        const data = props.context.data;
        switch (props.entity.TargetEntityType) {
            case TargetEntityType.Assignment:
                state.type = TargetCriteriaType.Assignment;
                if (Helper.hasValue(data.targetCodes)) {
                    state.kNrs = data.targetCodes.map((code) => {
                        return {
                            designation: code.Value,
                            knr: code.Key
                        };
                    })
                }
                break;
            case TargetEntityType.CustomReport:
                state.type = TargetCriteriaType.Report;

                if (Helper.hasValue(data.targetTemplateIds)) {
                    state.templates = data.targetTemplateIds.map(item => { return { Id: item.Key, Title: item.Value, Version: null } });                    
                }
                if (Helper.hasValue(props.value.Tags)) {
                    this.baseTagList = props.value.Tags;
                }
                state.tags = this.baseTagList;
                break;
        }
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.state = state;
        this.initApp();
    }

    private initApp = async () => {
        this.addTagButtonVisible = false;
        if (this.props.context.disableEntityType && !Helper.isNullOrEmpty(this.props.context.templateId)) {
            const result = await HTTPService.get<JsonResultClass>(`CrTemplate/Init?Id=${this.props.context.templateId}`);
            if (result.Code == 0) {
                this.crTemplate = result.Data["ReportStructure"];
                this.addTagButtonVisible = !this.crTemplate["Released"];
                this.setState({})
            } 
        }
    }

    private updateEntity = () => {
        let value: TargetCriterias = {
            Codes: [],
            Tags: [],
            Templates: []
        }
        switch (this.state.type) {
            case TargetCriteriaType.Assignment:
                value.Codes = this.state.kNrs.map((item) => { return item.knr });
                break;
            case TargetCriteriaType.Report:
                value.Templates = this.state.templates.map((item) => { return item.Id });
                value.Tags = this.state.tags;
                break;
        }
        this.props.onChange(this.props.field, value);
    }

    private setType = (updateEntity: boolean = true) => {
        let type: TargetCriteriaType = TargetCriteriaType.None;
        this.targetEntityType = this.props.entity.TargetEntityType;
        switch (this.targetEntityType) {
            case TargetEntityType.Assignment:
                type = TargetCriteriaType.Assignment;
                break;
            case TargetEntityType.CustomReport:
                type = TargetCriteriaType.Report;
                break;
        }
        this.setState({ type: type }, () => { if (updateEntity) { this.updateEntity } })
    }

    private createKNrField = () => {
        let props = this.factory.getDefaultSearchFieldProps();
        props.value = this.state.kNrs;
        props.multiSelectMode = true;
        props.field.searchWindowUrl = "DynamicSearch/Window/code?multi=true&displayPattern=[[designation]]";
        props.field.dataTextField = "designation";
        props.field.dataValueField = "knr";
        props.field.searchTextField = "designation";
        props.field.searchValueField = "knr";
        props.disabled = this.props.disabled;
        props.onChange = (_, value) => {
            this.setState({ kNrs: value }, this.updateEntity);
        }
        return (
            <div style={{ display: this.targetEntityType === TargetEntityType.Assignment ? "block" : "none" }}>
                {(this.props.disabled && this.state.kNrs.length === 0) ?
                    <label style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "inline-block", height: "18px", width: "auto" }}>{this.props.context.translations["WebSMS.ReportMetadata.ForAllCodes"]}</label> :
                    <FieldInstance label={this.props.context.translations["WebSMS.ReportMetadata.Codes"]}>
                        <IsSearchField {...props} />
                    </FieldInstance>
                }
            </div>
        );
    }

    private createTemplateField = () => {
        let props = this.factory.getDefaultSearchFieldProps();
        props.multiSelectMode = true;
        props.field.searchWindowUrl = "DynamicSearch/Window/crTemplate?multi=true&displayPattern=[[Title]]";
        props.field.dataTextField = "Title";
        props.field.dataValueField = "Id";
        props.field.searchTextField = "Title";
        props.field.searchValueField = "Id";
        props.disabled = this.props.disabled;
        props.onChange = (_, __, rawTemplates: {Id: string, Title: string, Version: number}[]) => {
            let templates = rawTemplates.map((item) => {
                return {
                    Id: item.Id,
                    Title: item.Title,
                    Version: item.Version
                }
            });
            this.setState({ templates: templates }, this.updateEntity);
        }
        props.value = this.state.templates;
        return (
            <div style={{ display: this.targetEntityType === TargetEntityType.CustomReport ? "block" : "none" }}>
                {
                    this.props.disabled && this.state.tags.length > 0 ? null : 
                    <FieldInstance label={this.props.context.translations["WebSMS.Report.ReportTemplates"]} fieldStyle={this.props.disabled ? this.contentStyle : {}}>
                        {
                            (this.props.disabled && this.state.templates.length === 0) ?
                                    <label style={this.labelStyle}> {this.props.context.translations["WebSMS.ReportMetadata.ForAllTemplates"]}</label> :
                                    <div style={{ paddingBottom: "5px", width: "100%", display: "flex", flexFlow: "row-reverse" }}>
                                        {this.createAddTemplateButton()}
                                        <div style={{ width: "100%", marginRight: "5px" }}>
                                            <IsSearchField {...props} />
                                        </div>
                                </div>
                        }
                            {
                                (!this.props.disabled && this.state.templates.length > 0) ?
                                <>
                                    <label>
                                        {this.props.context.translations["WebSMS.ReportMetadata.UseTags"]}
                                    </label>
                                    {
                                        this.props.disabled ? null :
                                            <>
                                                <br></br>
                                                <label onClick={this.loadTagsByTemplateIds} className={"downloadLabel"}>
                                                    {this.props.context.translations["WebSMS.ReportMetadata.LoadTagsFromTemplate"]}
                                                </label>
                                            </>
                                    }
                                </>
                                : null
                        }
                    </FieldInstance>
                }
            </div>
        );
    }

    private createAddTemplateButton = () => {
        if (Helper.isNullOrEmpty(this.props.context.templateId) || this.state.templates.findIndex(f => f.Id === this.props.context.templateId) > -1) {
            return null;
        }
        const props: ButtonProps = {
            handleClick: () => {
                const template = {
                    Id: this.props.context.templateId,
                    Title: this.crTemplate.Title,
                    Version: this.crTemplate.Version
                }
                const templates = this.state.templates;
                templates.push(template);
                this.setState({ templates: templates }, this.updateEntity);
            },
            iconName: "edit"
        }

        return <Button {...props}/>
    }

    private loadTagsByTemplateIds = async () => {
        const tags = await HTTPService.post<string[]>("ReportMetaData/GetAllQRTags", { templateIds: this.state.templates.map((item) => { return item.Id }) })
        this.setState({ tags: Helper.mergeLists(tags, this.state.tags) }, this.updateEntity);
    }

    private createTagMultiSelect = () => {
        const props: TagMultiSelectProps = {
            disabled: this.props.disabled,
            onChange: (tags: string[]) => { this.setState({ tags: tags }, this.updateEntity)},
            value: this.state.tags.map((x) => { return x }),
            buttonVisibile: this.addTagButtonVisible,
            onButtonClick: this.onButtonClick,
            templateId: this.props.context.templateId
        }
        return (
            <div style={{ display: this.targetEntityType === TargetEntityType.CustomReport ? "block" : "none" }}>
                {this.props.disabled && this.state.templates.length > 0 ? null :
                    <FieldInstance label={this.props.context.translations["WebSMS.Report.Question.Tags"]} fieldStyle={this.props.disabled ? this.contentStyle : {}}>
                        {
                            (this.props.disabled && this.state.tags.length === 0) ?
                                <label style={this.labelStyle}>
                                    {this.props.context.translations["WebSMS.ReportMetadata.ForAllTags"]}
                                </label> :
                                <div style={{ width: "100%" }}>
                                    <TagMultiSelect {...props} ref={(ref) => { this.tagMultiSelectRef = ref }} />
                                </div>
                        }
                    </FieldInstance>
                }
            </div>
        )
    }

    private onButtonClick = async () => {
        let defaultTag = "quick-report-";
        const en = Object.keys(this.props.entity.Name).find(f => f.includes("en"));
        if (!Helper.isNullOrEmpty(this.props.entity.Name[en]))
            defaultTag += this.props.entity.Name[en];
        else
            defaultTag += ReportMetaDataHelper.getDisplayText(this.props.entity.Name);
        defaultTag = defaultTag.trim().replace(" ", "-");
        const tag = await DialogHelper.prompt(this.props.context.translations["WebSMS.ReportMetadata.AddNewTag"], defaultTag);
        if (!Helper.isNullOrEmpty(tag)) {
            const tags = this.state.tags;
            tags.push(tag);
            this.tagMultiSelectRef.addTagToDataSource(tag);
            this.setState({ tags: tags }, () => {
                this.updateEntity();
                this.sheet.trigger(SheetEventType.Custom, { cmd: "tagAdded", data: tag });
            })
        }
    }

    componentDidUpdate() {
        if (this.targetEntityType !== this.props.entity.TargetEntityType) {
            this.setType();
        }
    }

    componentDidMount() {
        this.setType(false);
    }

    render() {
        return (
            <div className={"qra__targetCriteria"}>
                {this.createKNrField()}
                {this.createTagMultiSelect()}
                {this.createTemplateField()}
            </div>
        );
    }
}

interface TargetCriteriaProps {
    field: BaseField;
    value: TargetCriterias;
    onChange: (field, value) => void;
    entity: ReportDefinition;
    disabled: boolean;
    context: ReportMetaDataContext
}

interface TargetCriteriaState {
    type: TargetCriteriaType;
    kNrs: { designation: string, knr: number }[];
    templates: { Id: string, Title: string, Version: number }[];
    tags: string[]
}

enum TargetCriteriaType {
    None, Assignment, Report
}

class TagMultiSelect extends React.Component<TagMultiSelectProps, {dataSource: string[]}>{

    private multiSelectRef: any;
    private multiSelect: kendo.ui.MultiSelect;

    constructor(props: TagMultiSelectProps) {
        super(props);
        this.state = {
            dataSource: []
        }
    }

    addTagToDataSource = (tag: string) => {
        let tags = this.state.dataSource;
        tags.push(tag);
        tags = tags.filter((value, index, self) => {
            return self.indexOf(value) === index;
        }); 
        this.setState({ dataSource: tags }, () => {
            this.multiSelect.setDataSource(tags as any)
        });
    }

    private loadDataSource = async () => {
        const lst: string[] = [];
        if (!Helper.isNullOrEmpty(this.props.templateId)) {
            lst.push(this.props.templateId);
        }
        let tags = await HTTPService.post("ReportMetaData/GetAllQrTags", { templateIds: lst });
        tags = Helper.mergeLists(tags, this.props.value);
        this.setState({ dataSource: tags }, this.build)
    }

    private createButton = () => {
        const props: ButtonProps = {
            iconName: "plus",
            handleClick: this.props.onButtonClick,
            buttonStyle: {
                marginLeft: "5px"
            }
        }
        return <Button {...props}/>
    }

    private build = () => {
        this.multiSelect = $(this.multiSelectRef).kendoMultiSelect({
            value: this.props.value,
            enable: !this.props.disabled,
            dataSource: this.state.dataSource,
            change: (ev) => { this.props.onChange(ev.sender.value()) }
        }).data("kendoMultiSelect");
    }

    componentDidUpdate() {
        if (Helper.hasValue(this.multiSelect)) {
            this.multiSelect.value(this.props.value);
            this.multiSelect.enable(!this.props.disabled);
        }
    }

    componentDidMount() {
        this.loadDataSource();
    }
    
    render() {
        let style: React.CSSProperties = {
            width: "100%"
        };
        return (
            <div style={{ display: "flex", flexDirection: "row-reverse", alignItems: "center" }}>
                {(this.props.buttonVisibile && !this.props.disabled) ? this.createButton() : null}
                <select ref={(r) => this.multiSelectRef = r} style={style} />
            </div>
        );
    }
}

interface TagMultiSelectProps {
    onChange: (tags: string[]) => void;
    value: string[];
    disabled: boolean;
    templateId?: string;
    buttonVisibile: boolean;
    onButtonClick: () => void
}